import { api } from "@";

// API call to update notification status
export const updateStatus = (id) =>
  api.post(`/api/AdminNotifications/update-status/${id}?status=${true}`);
